import { FaRegCheckCircle } from "react-icons/fa";
import { StringParam, useQueryParams } from "use-query-params";
import FlexBox from "../../FlexBox";
import { Body1, Body2, H2 } from "../../Headings";
import ToggleSwitch from "../../ToggleSwitch";
import { PLUM_PURPLE_800, PRIMARY_800, SUCCESS_GREEN } from "../../colors";
import {
  Block1,
  SessionBulletIcon,
  SessionBulletRow,
  ToggleContainer,
} from "../styles";

const FinalConsentStep = ({ isEnabled, onToggle }) => {
  const [queryParams] = useQueryParams({
    aiConsentSource: StringParam,
  });
  const { aiConsentSource } = queryParams || {};

  return (
    <FlexBox column>
      <FlexBox column rowGap="2.5rem">
        <FlexBox column rowGap="0.5rem">
          <H2
            bold
            textAlign="center"
            color={PRIMARY_800}
            margin="-1.5rem 0 0 0"
          >
            You’re Always in Control
          </H2>
          <Body1 textAlign="center">
            Secure, private, and purpose-built for clinicians.
          </Body1>
        </FlexBox>
        <FlexBox column rowGap="1rem">
          <FlexBox columnGap="1.5rem">
            <SessionBulletRow columnGap="0.5rem">
              <SessionBulletIcon>
                <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
              </SessionBulletIcon>
              <Body1>Data remains within Amaha and is never shared.</Body1>
            </SessionBulletRow>
            <SessionBulletRow columnGap="0.5rem">
              <SessionBulletIcon>
                <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
              </SessionBulletIcon>
              <Body1>
                You have complete control when and how to use AI features.
              </Body1>
            </SessionBulletRow>
          </FlexBox>
          <SessionBulletRow columnGap="0.5rem">
            <SessionBulletIcon>
              <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
            </SessionBulletIcon>
            <Body1>
              All suggestions can be edited and are designed to support, not
              override, your clinical expertise and judgement.
            </Body1>
          </SessionBulletRow>
        </FlexBox>
      </FlexBox>

      {aiConsentSource !== "aiHome" && (
        <Block1>
          <FlexBox rowGap="0.5rem" padding="1rem" column>
            <Body1
              textAlign="left"
              rowGap="0.5rem"
              bold
              color={PLUM_PURPLE_800}
            >
              Start Exploring!
            </Body1>
            <Body2>
              You’ll find AI assistance available in the client profile, session
              notes, and AI chat assistance across your platform.
            </Body2>
          </FlexBox>
          <ToggleContainer>
            <Body2 bold>
              Enable session transcription to start generating session note
              summaries
            </Body2>
            <ToggleSwitch checked={isEnabled} handleToggle={onToggle} />
          </ToggleContainer>
        </Block1>
      )}
    </FlexBox>
  );
};

export default FinalConsentStep;
